import { LoadingStateEnum } from './types';
export class SiteWiseAssetCache {
    constructor() {
        this.assetCache = {};
        this.assetModelCache = {};
        this.propertyValueCache = {};
        this.hierarchyCache = {};
        this.errorCache = [];
        this.isDescribeAssetResponse = (assetAny) => assetAny.assetId != undefined;
    }
    storeErrors(err) {
        this.errorCache.push(err);
    }
    getAllErrors() {
        return this.errorCache;
    }
    convertToAssetSummary(assetDescription) {
        return {
            id: assetDescription.assetId,
            arn: assetDescription.assetArn,
            name: assetDescription.assetName,
            assetModelId: assetDescription.assetModelId,
            creationDate: assetDescription.assetCreationDate,
            lastUpdateDate: assetDescription.assetLastUpdateDate,
            status: assetDescription.assetStatus,
            hierarchies: assetDescription.assetHierarchies,
        };
    }
    assetPropertyValueKey(assetId, propertyId) {
        return assetId + ':' + propertyId;
    }
    getAssetSummary(assetId) {
        return this.assetCache[assetId];
    }
    storeAssetSummary(assetAny) {
        const assetSummary = this.isDescribeAssetResponse(assetAny)
            ? this.convertToAssetSummary(assetAny)
            : assetAny;
        if (assetSummary.id != undefined) {
            this.assetCache[assetSummary.id] = assetSummary;
        }
    }
    storeAssetSummaries(assetSummaryList) {
        assetSummaryList.forEach((summary) => {
            this.storeAssetSummary(summary);
        });
    }
    getAssetModel(assetModelId) {
        return this.assetModelCache[assetModelId];
    }
    storeAssetModel(assetModel) {
        if (assetModel.assetModelId != undefined) {
            this.assetModelCache[assetModel.assetModelId] = assetModel;
        }
    }
    getPropertyValue(assetId, propertyId) {
        return this.propertyValueCache[this.assetPropertyValueKey(assetId, propertyId)];
    }
    storePropertyValue(assetId, propertyId, assetPropertyValue) {
        this.propertyValueCache[this.assetPropertyValueKey(assetId, propertyId)] =
            assetPropertyValue;
    }
    getHierarchy(hierarchyId) {
        return this.hierarchyCache[hierarchyId];
    }
    newCachedAssetSummaryBlock() {
        return {
            assetIds: [],
            loadingStage: LoadingStateEnum.NOT_LOADED,
            paginationToken: undefined,
        };
    }
    setupHierarchyCache(hierarchyId) {
        let storedHierarchy = this.getHierarchy(hierarchyId);
        if (!storedHierarchy) {
            storedHierarchy = this.newCachedAssetSummaryBlock();
            this.hierarchyCache[hierarchyId] = storedHierarchy;
        }
        return storedHierarchy;
    }
    appendHierarchyResults(hierarchyId, assetSummaries, loadingState, paginationToken) {
        const storedHierarchy = this.setupHierarchyCache(hierarchyId);
        storedHierarchy.loadingStage = loadingState;
        storedHierarchy.paginationToken = paginationToken;
        if (!assetSummaries) {
            return;
        }
        assetSummaries.forEach((assetSummary) => {
            if (assetSummary.id != undefined) {
                this.storeAssetSummary(assetSummary);
                storedHierarchy.assetIds.push(assetSummary.id);
            }
        });
    }
    setHierarchyLoadingState(hierarchyId, loadingState) {
        const storedHierarchy = this.setupHierarchyCache(hierarchyId);
        storedHierarchy.loadingStage = loadingState;
    }
}
